import { Stack, Text } from '@mantine/core';
import { useState } from 'react';

export default function WorkOrderTitle({ title }: { title: string }) {
  const [showAll, setShowAll] = useState(false);
  const [hovered, setHovered] = useState(false);

  return (
    <Stack
      gap={2}
      title={title}
      style={{ cursor: 'pointer' }}
      onClick={() => setShowAll((prev) => !prev)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Text size="xs" c="dimmed">
        Title
      </Text>
      <Text
        size="sm"
        fw={600}
        truncate={!showAll}
        c={hovered ? 'blue' : undefined}
      >
        {title}
      </Text>
    </Stack>
  );
}
